import { INDUSTRY_CATEGORIES } from '../../../../constants/industryCategories';
import { categoryOnlyPack } from './packBuilder';

const sandboxCategory = INDUSTRY_CATEGORIES.find((c) => c.id === 'sandbox');
if (!sandboxCategory) {
  throw new Error('sandbox category missing from INDUSTRY_CATEGORIES');
}

/** Metadata-only pack; content merged at runtime via mergeSandboxPacks(). */
export const sandboxPack = categoryOnlyPack('sandbox', sandboxCategory);